
<v-group :zIndex='3' ref="container" :config="configGroup" @click="selected" @tap="selected" @touchend="dragend"
  @dragmove="dragmove" @dragstart="dragstart" @dragend="dragend">
  <v-group>
    <v-rect :zIndex='3' v-if="table.forme === 'rect'" ref="rect" :config="configRectangle"></v-rect>
    <v-circle :zIndex='4' v-if="table.forme === 'circle'" ref="circle" :config="configCircle"></v-circle>
    <v-rect v-if="getWarning && !getStyleEdition" :zIndex='5' ref="rectWarn"
      :config="configRectangleWarning"></v-rect>
  </v-group>
  <v-group :config="{ listening: false }">
    <v-text :zIndex='6' :config="configText" ref="text"></v-text>
    <v-text :zIndex='6' :config="configTextCouv" ref="text"></v-text>
    <v-text :zIndex='6' v-if="!getStyleEdition" :config="configTextTimer" ref="text"></v-text>
  </v-group>
  <v-group v-if="tableIsLock && !getStyleEdition">
    <v-path :config="configCadena"></v-path>
  </v-group>
</v-group>
